module.exports = __webpack_public_path__ + "img/hero_image.026a910e.svg";